import http from "@/plugins/axios_plugin";

class ServiceRodadas {
  index() {
    return http.get("/api/rodadas/listar");
  }

  abrir(rodada_id) {
    return http.get("/api/rodadas/" + rodada_id + "/abrir");
  }

  salvar(rodada) {
    return http.post("/api/rodadas/salvar", rodada);
  }

  atualizar(rodada, rodada_id) {
    return http.post("/api/rodadas/" + rodada_id + "/atualizar", rodada);
  }

  carregarAdm() {
    return http.get("/api/rodadas/administradores");
  }

  carregarAdmRodada(rodada_id) {
    return http.get("/api/rodadas/" + rodada_id + "/administradores");
  }

  carregarFornecedores(rodada_id) {
    return http.get("/api/rodadas/" + rodada_id + "/fornecedores");
  }

  carregarFornecedoresRodada(rodada_id) {
    return http.get("/api/rodadas/" + rodada_id + "/fornecedores/rodada");
  }

  /* salvarFornecedores (rodada_id, fornecedores) {
        return http.post('/api/rodadas/' + rodada_id + '/fornecedores/salvar', fornecedores)
    } */

  salvarFornecedor(rodada_id, fornecedor_id) {
    return http.post(
      "/api/rodadas/" + rodada_id + "/fornecedor/" + fornecedor_id + "/salvar"
    );
  }

  excluirFornecedor(rodada_id, fornecedor_id) {
    return http.post(
      "/api/rodadas/" + rodada_id + "/fornecedor/" + fornecedor_id + "/excluir"
    );
  }

  carregarRepresentantes(rodada_id) {
    return http.get("/api/rodadas/" + rodada_id + "/representantes");
  }

  carregarRepresentantesRodada(rodada_id) {
    return http.get("/api/rodadas/" + rodada_id + "/representantes/rodada");
  }

  /* salvarRepresentantes (rodada_id, representantes) {
        return http.post('/api/rodadas/' + rodada_id + '/representantes/salvar', representantes)
    } */

  salvarRepresentante(rodada_id, representante_id) {
    return http.post(
      "/api/rodadas/" +
        rodada_id +
        "/representante/" +
        representante_id +
        "/salvar"
    );
  }

  excluirRepresentante(rodada_id, representante_id) {
    return http.post(
      "/api/rodadas/" +
        rodada_id +
        "/representante/" +
        representante_id +
        "/excluir"
    );
  }

  carregarClientes(rodada_id) {
    return http.get("/api/rodadas/" + rodada_id + "/clientes");
  }

  carregarClientesRodada(rodada_id) {
    return http.get("/api/rodadas/" + rodada_id + "/clientes/rodada");
  }

  /* salvarClientes (rodada_id, clientes) {
        return http.post('/api/rodadas/' + rodada_id + '/clientes/salvar', clientes)
    } */

  salvarCliente(rodada_id, cliente_id) {
    return http.post(
      "/api/rodadas/" + rodada_id + "/cliente/" + cliente_id + "/salvar"
    );
  }

  excluirCliente(rodada_id, cliente_id) {
    return http.post(
      "/api/rodadas/" + rodada_id + "/cliente/" + cliente_id + "/excluir"
    );
  }

  salvarClientePrazo(rodada_id, cliente_id, prazo) {
    return http.post(
      "/api/rodadas/" + rodada_id + "/clientes/" + cliente_id + "/prazo",
      prazo
    );
  }

  inscreverCliente(rodada_id, cliente_id) {
    return http.post(
      "/api/rodadas/" + rodada_id + "/clientes/" + cliente_id + "/inscrever"
    );
  }

  cancelarInscricaoCliente(rodada_id, cliente_id) {
    return http.post(
      "/api/rodadas/" +
        rodada_id +
        "/clientes/" +
        cliente_id +
        "/inscrever/cancelar"
    );
  }

  carregarStandsRodada(rodada_id) {
    return http.get("/api/rodadas/" + rodada_id + "/stands");
  }

  salvarStand(rodada_id, stand) {
    return http.post("/api/rodadas/" + rodada_id + "/stands/salvar", stand);
  }

  getProprietario(rodada_id, stand_id) {
    return http.get(
      "/api/rodadas/" + rodada_id + "/stands/" + stand_id + "/proprietario"
    );
  }

  editarStand(rodada_id, stand_id) {
    return http.get(
      "/api/rodadas/" + rodada_id + "/stands/" + stand_id + "/editar"
    );
  }

  atualizarStand(rodada_id, stand_id, stand) {
    return http.post(
      "/api/rodadas/" + rodada_id + "/stands/" + stand_id + "/atualizar",
      stand
    );
  }

  excluirStand(rodada_id, stand_id) {
    return http.post(
      "/api/rodadas/" + rodada_id + "/stands/" + stand_id + "/excluir"
    );
  }

  carregarRodadasAnteriores(rodada_id) {
    return http.get("/api/rodadas/" + rodada_id + "/stands/copiar/rodadas");
  }

  copiarStands(rodada_id, rodada_copia_id) {
    return http.post(
      "/api/rodadas/" + rodada_id + "/stands/copiar/" + rodada_copia_id
    );
  }

  importarClientes(rodada_id) {
    return http.post("/api/rodadas/" + rodada_id + "/importar/clientes");
  }

  importarRepresentantes(rodada_id) {
    return http.post("/api/rodadas/" + rodada_id + "/importar/representantes");
  }

  importarFornecedores(rodada_id) {
    return http.post("/api/rodadas/" + rodada_id + "/importar/fornecedores");
  }

  carregarRodadasCliente() {
    return http.get("/api/rodadas/cliente");
  }

  listarStandsMapa(rodadaId) {
    return http.get(`/api/stands/${rodadaId}`);
  }
  salvarStandMapa(rodadaId, dados) {
    return http.post(`/api/stands/${rodadaId}`, dados);
  }
}

export default new ServiceRodadas();
